import {
  AVP,
  KPI,
  Snapshot,
  ChartDataPoint,
  LoanOfficer,
  Director,
  LoanOfficerWithContext,
} from '../types'

export const mockAVPs: AVP[] = [
  {
    id: 'avp-1',
    name: 'Sarah Jenkins',
    initials: 'SJ',
    division: 'West',
    rank: 1,
    previousRank: 2,
    loCount: 32,
    loanVolume: 145000000,
    totalRevenue: 2150000,
    loansClosed: 175,
    avgRevenue: 12285,
    snapshotStatus: 'In Progress',
    lastUpdated: '2 mins ago',
  },
  {
    id: 'avp-2',
    name: 'Marcus Chen',
    initials: 'MC',
    division: 'Northeast',
    rank: 2,
    previousRank: 1,
    loCount: 28,
    loanVolume: 138000000,
    totalRevenue: 1980000,
    loansClosed: 160,
    avgRevenue: 12375,
    snapshotStatus: 'In Progress',
    lastUpdated: '5 mins ago',
  },
  {
    id: 'avp-3',
    name: 'Elena Rodriguez',
    initials: 'ER',
    division: 'Southeast',
    rank: 3,
    previousRank: 5,
    loCount: 35,
    loanVolume: 125000000,
    totalRevenue: 1850000,
    loansClosed: 155,
    avgRevenue: 11935,
    snapshotStatus: 'In Progress',
    lastUpdated: '12 mins ago',
  },
  {
    id: 'avp-4',
    name: 'David Kim',
    initials: 'DK',
    division: 'Central',
    rank: 4,
    previousRank: 4,
    loCount: 24,
    loanVolume: 110000000,
    totalRevenue: 1650000,
    loansClosed: 130,
    avgRevenue: 12692,
    snapshotStatus: 'In Progress',
    lastUpdated: '1 hour ago',
  },
  {
    id: 'avp-5',
    name: 'James Wilson',
    initials: 'JW',
    division: 'Mountain',
    rank: 5,
    previousRank: 3,
    loCount: 22,
    loanVolume: 98000000,
    totalRevenue: 1450000,
    loansClosed: 115,
    avgRevenue: 12608,
    snapshotStatus: 'In Progress',
    lastUpdated: '3 hours ago',
  },
  {
    id: 'avp-6',
    name: 'Anita Patel',
    initials: 'AP',
    division: 'West',
    rank: 6,
    previousRank: 8,
    loCount: 18,
    loanVolume: 85000000,
    totalRevenue: 1250000,
    loansClosed: 95,
    avgRevenue: 13157,
    snapshotStatus: 'In Progress',
    lastUpdated: '4 hours ago',
  },
  {
    id: 'avp-7',
    name: 'Michael Chang',
    initials: 'MC',
    division: 'Northeast',
    rank: 7,
    previousRank: 7,
    loCount: 19,
    loanVolume: 82000000,
    totalRevenue: 1180000,
    loansClosed: 92,
    avgRevenue: 12826,
    snapshotStatus: 'In Progress',
    lastUpdated: '1 day ago',
  },
  {
    id: 'avp-8',
    name: 'Rachel Green',
    initials: 'RG',
    division: 'Southeast',
    rank: 8,
    previousRank: 6,
    loCount: 20,
    loanVolume: 79000000,
    totalRevenue: 1100000,
    loansClosed: 88,
    avgRevenue: 12500,
    snapshotStatus: 'In Progress',
    lastUpdated: '1 day ago',
  },
  {
    id: 'avp-9',
    name: 'Thomas Wright',
    initials: 'TW',
    division: 'Central',
    rank: 9,
    previousRank: 11,
    loCount: 15,
    loanVolume: 65000000,
    totalRevenue: 950000,
    loansClosed: 75,
    avgRevenue: 12666,
    snapshotStatus: 'In Progress',
    lastUpdated: '2 days ago',
  },
  {
    id: 'avp-10',
    name: 'Olivia Martinez',
    initials: 'OM',
    division: 'Mountain',
    rank: 10,
    previousRank: 9,
    loCount: 14,
    loanVolume: 58000000,
    totalRevenue: 820000,
    loansClosed: 65,
    avgRevenue: 12615,
    snapshotStatus: 'In Progress',
    lastUpdated: '2 days ago',
  },
  {
    id: 'avp-11',
    name: 'William Taylor',
    initials: 'WT',
    division: 'West',
    rank: 11,
    previousRank: 10,
    loCount: 12,
    loanVolume: 45000000,
    totalRevenue: 650000,
    loansClosed: 52,
    avgRevenue: 12500,
    snapshotStatus: 'In Progress',
    lastUpdated: '3 days ago',
  },
  {
    id: 'avp-12',
    name: 'Sophia Lee',
    initials: 'SL',
    division: 'Northeast',
    rank: 12,
    previousRank: 12,
    loCount: 8,
    loanVolume: 28000000,
    totalRevenue: 410000,
    loansClosed: 32,
    avgRevenue: 12812,
    snapshotStatus: 'In Progress',
    lastUpdated: '3 days ago',
  },
]

export const mockKPIs: KPI[] = [
  {
    id: 'kpi-1',
    title: 'Total Loan Volume',
    value: 1058000000,
    format: 'short-currency',
    trend: 8.4,
    trendDirection: 'up',
    history: [850, 890, 870, 920, 980, 1058],
  },
  {
    id: 'kpi-3',
    title: 'Avg Revenue Per Loan',
    value: 12512,
    format: 'currency',
    trend: -1.2,
    trendDirection: 'down',
    history: [12800, 12750, 12600, 12650, 12580, 12512],
  },
  {
    id: 'kpi-4',
    title: 'Total Loans Closed',
    value: 1234,
    format: 'number',
    trend: 5.2,
    trendDirection: 'up',
    history: [980, 1020, 1005, 1100, 1150, 1234],
  },
  {
    id: 'kpi-5',
    title: 'Active AVPs',
    value: 12,
    format: 'number',
    trend: 0,
    trendDirection: 'flat',
    history: [11, 11, 12, 12, 12, 12],
  },
  {
    id: 'kpi-6',
    title: 'Total LO Count',
    value: 247,
    format: 'number',
    trend: 2.5,
    trendDirection: 'up',
    history: [230, 235, 238, 240, 242, 247],
  },
]

export const mockSnapshots: Snapshot[] = [
  {
    id: 'snap-1',
    month: 'March',
    year: 2026,
    status: 'Finalized Snapshot',
    topWinnerId: 'avp-2',
    totalVolume: 980000000,
    totalRevenue: 14200000,
    lockedAt: '2026-04-01T00:00:00Z',
  },
  {
    id: 'snap-2',
    month: 'February',
    year: 2026,
    status: 'Finalized Snapshot',
    topWinnerId: 'avp-1',
    totalVolume: 920000000,
    totalRevenue: 13400000,
    lockedAt: '2026-03-01T00:00:00Z',
  },
  {
    id: 'snap-3',
    month: 'January',
    year: 2026,
    status: 'Finalized Snapshot',
    topWinnerId: 'avp-5',
    totalVolume: 870000000,
    totalRevenue: 12500000,
    lockedAt: '2026-02-01T00:00:00Z',
  },
  {
    id: 'snap-4',
    month: 'December',
    year: 2025,
    status: 'Finalized Snapshot',
    topWinnerId: 'avp-2',
    totalVolume: 890000000,
    totalRevenue: 12800000,
    lockedAt: '2026-01-01T00:00:00Z',
  },
  {
    id: 'snap-5',
    month: 'November',
    year: 2025,
    status: 'Finalized Snapshot',
    topWinnerId: 'avp-4',
    totalVolume: 850000000,
    totalRevenue: 12100000,
    lockedAt: '2025-12-01T00:00:00Z',
  },
]

export const mockTrendData: ChartDataPoint[] = [
  { name: 'Nov', revenue: 12.1, volume: 850 },
  { name: 'Dec', revenue: 12.8, volume: 890 },
  { name: 'Jan', revenue: 12.5, volume: 870 },
  { name: 'Feb', revenue: 13.4, volume: 920 },
  { name: 'Mar', revenue: 14.2, volume: 980 },
  { name: 'Apr', revenue: 15.4, volume: 1058 },
]

// Pre-built historical leaderboards (frozen rankings per snapshot)
export const historicalLeaderboards: Record<string, AVP[]> = {
  // March 2026 — winner: avp-2 Marcus Chen
  'snap-1': [
    {
      ...mockAVPs[1],
      rank: 1,
      previousRank: 3,
      loanVolume: 132000000,
      totalRevenue: 1990000,
      loansClosed: 158,
      avgRevenue: 12595,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[0],
      rank: 2,
      previousRank: 1,
      loanVolume: 128000000,
      totalRevenue: 1880000,
      loansClosed: 152,
      avgRevenue: 12368,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[3],
      rank: 3,
      previousRank: 4,
      loanVolume: 115000000,
      totalRevenue: 1720000,
      loansClosed: 138,
      avgRevenue: 12463,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[2],
      rank: 4,
      previousRank: 6,
      loanVolume: 108000000,
      totalRevenue: 1610000,
      loansClosed: 130,
      avgRevenue: 12384,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[4],
      rank: 5,
      previousRank: 2,
      loanVolume: 95000000,
      totalRevenue: 1410000,
      loansClosed: 112,
      avgRevenue: 12589,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[5],
      rank: 6,
      previousRank: 9,
      loanVolume: 82000000,
      totalRevenue: 1190000,
      loansClosed: 92,
      avgRevenue: 12934,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[7],
      rank: 7,
      previousRank: 5,
      loanVolume: 78000000,
      totalRevenue: 1110000,
      loansClosed: 88,
      avgRevenue: 12613,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[6],
      rank: 8,
      previousRank: 7,
      loanVolume: 75000000,
      totalRevenue: 1050000,
      loansClosed: 84,
      avgRevenue: 12500,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[9],
      rank: 9,
      previousRank: 10,
      loanVolume: 60000000,
      totalRevenue: 850000,
      loansClosed: 68,
      avgRevenue: 12500,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[8],
      rank: 10,
      previousRank: 8,
      loanVolume: 58000000,
      totalRevenue: 820000,
      loansClosed: 65,
      avgRevenue: 12615,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[10],
      rank: 11,
      previousRank: 11,
      loanVolume: 42000000,
      totalRevenue: 605000,
      loansClosed: 49,
      avgRevenue: 12346,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[11],
      rank: 12,
      previousRank: 12,
      loanVolume: 26000000,
      totalRevenue: 380000,
      loansClosed: 30,
      avgRevenue: 12666,
      snapshotStatus: 'Finalized Snapshot',
    },
  ],
  // February 2026 — winner: avp-1 Sarah Jenkins
  'snap-2': [
    {
      ...mockAVPs[0],
      rank: 1,
      previousRank: 2,
      loanVolume: 138000000,
      totalRevenue: 2050000,
      loansClosed: 165,
      avgRevenue: 12424,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[4],
      rank: 2,
      previousRank: 1,
      loanVolume: 105000000,
      totalRevenue: 1560000,
      loansClosed: 124,
      avgRevenue: 12580,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[1],
      rank: 3,
      previousRank: 4,
      loanVolume: 118000000,
      totalRevenue: 1780000,
      loansClosed: 142,
      avgRevenue: 12535,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[3],
      rank: 4,
      previousRank: 3,
      loanVolume: 102000000,
      totalRevenue: 1530000,
      loansClosed: 122,
      avgRevenue: 12540,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[2],
      rank: 5,
      previousRank: 7,
      loanVolume: 98000000,
      totalRevenue: 1460000,
      loansClosed: 118,
      avgRevenue: 12372,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[7],
      rank: 6,
      previousRank: 5,
      loanVolume: 80000000,
      totalRevenue: 1140000,
      loansClosed: 91,
      avgRevenue: 12527,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[6],
      rank: 7,
      previousRank: 6,
      loanVolume: 76000000,
      totalRevenue: 1080000,
      loansClosed: 86,
      avgRevenue: 12558,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[5],
      rank: 8,
      previousRank: 11,
      loanVolume: 72000000,
      totalRevenue: 1050000,
      loansClosed: 82,
      avgRevenue: 12804,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[8],
      rank: 9,
      previousRank: 9,
      loanVolume: 62000000,
      totalRevenue: 880000,
      loansClosed: 70,
      avgRevenue: 12571,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[9],
      rank: 10,
      previousRank: 8,
      loanVolume: 56000000,
      totalRevenue: 790000,
      loansClosed: 63,
      avgRevenue: 12539,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[10],
      rank: 11,
      previousRank: 10,
      loanVolume: 40000000,
      totalRevenue: 580000,
      loansClosed: 47,
      avgRevenue: 12340,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[11],
      rank: 12,
      previousRank: 12,
      loanVolume: 25000000,
      totalRevenue: 360000,
      loansClosed: 28,
      avgRevenue: 12857,
      snapshotStatus: 'Finalized Snapshot',
    },
  ],
  // January 2026 — winner: avp-5 James Wilson
  'snap-3': [
    {
      ...mockAVPs[4],
      rank: 1,
      previousRank: 3,
      loanVolume: 125000000,
      totalRevenue: 1850000,
      loansClosed: 148,
      avgRevenue: 12500,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[0],
      rank: 2,
      previousRank: 1,
      loanVolume: 120000000,
      totalRevenue: 1780000,
      loansClosed: 142,
      avgRevenue: 12535,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[3],
      rank: 3,
      previousRank: 5,
      loanVolume: 108000000,
      totalRevenue: 1620000,
      loansClosed: 128,
      avgRevenue: 12656,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[1],
      rank: 4,
      previousRank: 2,
      loanVolume: 102000000,
      totalRevenue: 1500000,
      loansClosed: 120,
      avgRevenue: 12500,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[7],
      rank: 5,
      previousRank: 4,
      loanVolume: 88000000,
      totalRevenue: 1280000,
      loansClosed: 102,
      avgRevenue: 12549,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[2],
      rank: 6,
      previousRank: 8,
      loanVolume: 85000000,
      totalRevenue: 1240000,
      loansClosed: 99,
      avgRevenue: 12525,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[6],
      rank: 7,
      previousRank: 6,
      loanVolume: 70000000,
      totalRevenue: 990000,
      loansClosed: 79,
      avgRevenue: 12531,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[5],
      rank: 8,
      previousRank: 12,
      loanVolume: 64000000,
      totalRevenue: 920000,
      loansClosed: 73,
      avgRevenue: 12602,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[9],
      rank: 9,
      previousRank: 7,
      loanVolume: 60000000,
      totalRevenue: 840000,
      loansClosed: 67,
      avgRevenue: 12537,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[8],
      rank: 10,
      previousRank: 9,
      loanVolume: 55000000,
      totalRevenue: 770000,
      loansClosed: 62,
      avgRevenue: 12419,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[10],
      rank: 11,
      previousRank: 10,
      loanVolume: 38000000,
      totalRevenue: 540000,
      loansClosed: 44,
      avgRevenue: 12272,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[11],
      rank: 12,
      previousRank: 11,
      loanVolume: 22000000,
      totalRevenue: 320000,
      loansClosed: 26,
      avgRevenue: 12307,
      snapshotStatus: 'Finalized Snapshot',
    },
  ],
  // December 2025 — winner: avp-2 Marcus Chen
  'snap-4': [
    {
      ...mockAVPs[1],
      rank: 1,
      previousRank: 2,
      loanVolume: 130000000,
      totalRevenue: 1920000,
      loansClosed: 152,
      avgRevenue: 12631,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[3],
      rank: 2,
      previousRank: 1,
      loanVolume: 115000000,
      totalRevenue: 1700000,
      loansClosed: 135,
      avgRevenue: 12592,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[0],
      rank: 3,
      previousRank: 4,
      loanVolume: 110000000,
      totalRevenue: 1640000,
      loansClosed: 130,
      avgRevenue: 12615,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[4],
      rank: 4,
      previousRank: 3,
      loanVolume: 96000000,
      totalRevenue: 1410000,
      loansClosed: 112,
      avgRevenue: 12589,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[7],
      rank: 5,
      previousRank: 6,
      loanVolume: 86000000,
      totalRevenue: 1240000,
      loansClosed: 99,
      avgRevenue: 12525,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[2],
      rank: 6,
      previousRank: 5,
      loanVolume: 82000000,
      totalRevenue: 1180000,
      loansClosed: 94,
      avgRevenue: 12553,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[6],
      rank: 7,
      previousRank: 7,
      loanVolume: 72000000,
      totalRevenue: 1020000,
      loansClosed: 81,
      avgRevenue: 12592,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[5],
      rank: 8,
      previousRank: 10,
      loanVolume: 68000000,
      totalRevenue: 970000,
      loansClosed: 77,
      avgRevenue: 12597,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[9],
      rank: 9,
      previousRank: 8,
      loanVolume: 58000000,
      totalRevenue: 810000,
      loansClosed: 64,
      avgRevenue: 12656,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[8],
      rank: 10,
      previousRank: 9,
      loanVolume: 52000000,
      totalRevenue: 730000,
      loansClosed: 58,
      avgRevenue: 12586,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[10],
      rank: 11,
      previousRank: 11,
      loanVolume: 36000000,
      totalRevenue: 510000,
      loansClosed: 41,
      avgRevenue: 12439,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[11],
      rank: 12,
      previousRank: 12,
      loanVolume: 20000000,
      totalRevenue: 290000,
      loansClosed: 24,
      avgRevenue: 12083,
      snapshotStatus: 'Finalized Snapshot',
    },
  ],
  // November 2025 — winner: avp-4 David Kim
  'snap-5': [
    {
      ...mockAVPs[3],
      rank: 1,
      previousRank: 2,
      loanVolume: 122000000,
      totalRevenue: 1810000,
      loansClosed: 142,
      avgRevenue: 12746,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[1],
      rank: 2,
      previousRank: 1,
      loanVolume: 118000000,
      totalRevenue: 1740000,
      loansClosed: 138,
      avgRevenue: 12608,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[0],
      rank: 3,
      previousRank: 5,
      loanVolume: 102000000,
      totalRevenue: 1500000,
      loansClosed: 119,
      avgRevenue: 12605,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[4],
      rank: 4,
      previousRank: 3,
      loanVolume: 92000000,
      totalRevenue: 1340000,
      loansClosed: 106,
      avgRevenue: 12641,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[2],
      rank: 5,
      previousRank: 4,
      loanVolume: 86000000,
      totalRevenue: 1240000,
      loansClosed: 99,
      avgRevenue: 12525,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[7],
      rank: 6,
      previousRank: 7,
      loanVolume: 78000000,
      totalRevenue: 1120000,
      loansClosed: 89,
      avgRevenue: 12584,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[6],
      rank: 7,
      previousRank: 6,
      loanVolume: 70000000,
      totalRevenue: 990000,
      loansClosed: 78,
      avgRevenue: 12692,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[5],
      rank: 8,
      previousRank: 9,
      loanVolume: 62000000,
      totalRevenue: 880000,
      loansClosed: 70,
      avgRevenue: 12571,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[9],
      rank: 9,
      previousRank: 8,
      loanVolume: 54000000,
      totalRevenue: 760000,
      loansClosed: 60,
      avgRevenue: 12666,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[8],
      rank: 10,
      previousRank: 10,
      loanVolume: 48000000,
      totalRevenue: 670000,
      loansClosed: 53,
      avgRevenue: 12641,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[10],
      rank: 11,
      previousRank: 11,
      loanVolume: 32000000,
      totalRevenue: 460000,
      loansClosed: 36,
      avgRevenue: 12777,
      snapshotStatus: 'Finalized Snapshot',
    },
    {
      ...mockAVPs[11],
      rank: 12,
      previousRank: 12,
      loanVolume: 18000000,
      totalRevenue: 260000,
      loansClosed: 22,
      avgRevenue: 11818,
      snapshotStatus: 'Finalized Snapshot',
    },
  ],
}

// Deterministic pseudo-random based on string seed
function seededRandom(seed: string) {
  let h = 2166136261
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i)
    h = Math.imul(h, 16777619)
  }
  return () => {
    h = Math.imul(h ^ (h >>> 15), 2246822507)
    h = Math.imul(h ^ (h >>> 13), 3266489909)
    h ^= h >>> 16
    return ((h >>> 0) % 100000) / 100000
  }
}

const FIRST_NAMES = [
  'Alex',
  'Jamie',
  'Morgan',
  'Taylor',
  'Casey',
  'Jordan',
  'Riley',
  'Avery',
  'Drew',
  'Quinn',
  'Reese',
  'Kai',
  'Sage',
  'River',
  'Skyler',
  'Cameron',
  'Parker',
  'Logan',
  'Hayden',
  'Rowan',
]
const LAST_NAMES = [
  'Anderson',
  'Brooks',
  'Collins',
  'Diaz',
  'Edwards',
  'Fischer',
  'Gordon',
  'Harris',
  'Ingram',
  'Jameson',
  'Kelly',
  'Lawson',
  'Murphy',
  'Nelson',
  'O\u0027Brien',
  'Patel',
  'Quinn',
  'Reed',
  'Singh',
  'Torres',
]
const PRODUCTS = ['Conventional', 'FHA', 'VA', 'Jumbo', 'USDA', 'Refinance']
const STATUSES: Array<'Closed' | 'Funded' | 'In Underwriting'> = [
  'Closed',
  'Funded',
  'In Underwriting',
]

export function getLoanOfficersForAvp(avp: AVP): LoanOfficer[] {
  const rand = seededRandom(avp.id)

  // Distribute the AVP totals across LOs with some variance
  const officerCount = avp.loCount
  const officers: LoanOfficer[] = []

  // Build raw weights, then normalize to match avp totals
  const weights = Array.from({ length: officerCount }, () => 0.5 + rand() * 1.5)
  const weightSum = weights.reduce((a, b) => a + b, 0)

  for (let i = 0; i < officerCount; i++) {
    const share = weights[i] / weightSum
    const loansClosed = Math.max(2, Math.round(avp.loansClosed * share))
    const loanVolume = Math.round(avp.loanVolume * share)
    const totalRevenue = Math.round(avp.totalRevenue * share)
    const first = FIRST_NAMES[Math.floor(rand() * FIRST_NAMES.length)]
    const last = LAST_NAMES[Math.floor(rand() * LAST_NAMES.length)]
    const name = `${first} ${last}`
    const initials = (first[0] + last[0]).toUpperCase()

    // Generate loans for this LO that sum to loanVolume / totalRevenue
    const loans: Loan[] = []
    const loanWeights = Array.from(
      { length: loansClosed },
      () => 0.5 + rand() * 1.5,
    )
    const lwSum = loanWeights.reduce((a, b) => a + b, 0)
    for (let j = 0; j < loansClosed; j++) {
      const lShare = loanWeights[j] / lwSum
      const amount = Math.round(loanVolume * lShare)
      const revenue = Math.round(totalRevenue * lShare)
      const day = 1 + Math.floor(rand() * 28)
      const product = PRODUCTS[Math.floor(rand() * PRODUCTS.length)]
      const status = STATUSES[Math.floor(rand() * STATUSES.length)]
      const borrowerFirst = FIRST_NAMES[Math.floor(rand() * FIRST_NAMES.length)]
      const borrowerLast = LAST_NAMES[Math.floor(rand() * LAST_NAMES.length)]
      loans.push({
        id: `${avp.id}-lo${i}-loan${j}`,
        borrower: `${borrowerFirst} ${borrowerLast}`,
        amount,
        revenue,
        closeDate: `2026-04-${String(day).padStart(2, '0')}`,
        status,
        product,
      })
    }

    officers.push({
      id: `${avp.id}-lo${i}`,
      name,
      initials,
      loansClosed,
      loanVolume,
      totalRevenue,
      loans,
    })
  }

  // Sort by revenue desc
  return officers.sort((a, b) => b.totalRevenue - a.totalRevenue)
}

export function getDirectorsForAvp(avp: AVP): Director[] {
  const rand = seededRandom(`${avp.id}-dirs`)
  const allOfficers = getLoanOfficersForAvp(avp)

  // 2-4 directors per AVP, but never more than the LO count
  const directorCount = Math.max(2, Math.min(4, Math.ceil(avp.loCount / 4)))

  // Build directors with deterministic names
  const directors: Director[] = []
  for (let i = 0; i < directorCount; i++) {
    const first = FIRST_NAMES[Math.floor(rand() * FIRST_NAMES.length)]
    const last = LAST_NAMES[Math.floor(rand() * LAST_NAMES.length)]
    directors.push({
      id: `${avp.id}-dir${i}`,
      name: `${first} ${last}`,
      initials: (first[0] + last[0]).toUpperCase(),
      loCount: 0,
      loansClosed: 0,
      loanVolume: 0,
      totalRevenue: 0,
      avgRevenue: 0,
      loanOfficers: [],
    })
  }

  // Assign each LO to a director using a weighted distribution so directors have varying team sizes
  const dirWeights = Array.from(
    { length: directorCount },
    () => 0.5 + rand() * 1.5,
  )
  const dirWeightSum = dirWeights.reduce((a, b) => a + b, 0)
  const targetCounts = dirWeights.map((w) =>
    Math.max(1, Math.round((w / dirWeightSum) * allOfficers.length)),
  )
  // Fix totals to match allOfficers.length
  let diff = allOfficers.length - targetCounts.reduce((a, b) => a + b, 0)
  let idx = 0
  while (diff !== 0) {
    if (diff > 0) {
      targetCounts[idx % directorCount]++
      diff--
    } else {
      if (targetCounts[idx % directorCount] > 1) {
        targetCounts[idx % directorCount]--
        diff++
      }
    }
    idx++
  }

  let officerIdx = 0
  for (let d = 0; d < directorCount; d++) {
    const count = targetCounts[d]
    for (let k = 0; k < count && officerIdx < allOfficers.length; k++) {
      const lo = allOfficers[officerIdx]
      directors[d].loanOfficers.push(lo)
      directors[d].loansClosed += lo.loansClosed
      directors[d].loanVolume += lo.loanVolume
      directors[d].totalRevenue += lo.totalRevenue
      officerIdx++
    }
    directors[d].loCount = directors[d].loanOfficers.length
    directors[d].avgRevenue =
      directors[d].loansClosed > 0
        ? directors[d].totalRevenue / directors[d].loansClosed
        : 0
  }

  // Sort directors by avg revenue desc
  return directors.sort((a, b) => b.avgRevenue - a.avgRevenue)
}

// Flatten all directors across all AVPs with parent context
export function getAllDirectors(avps: AVP[]): Director[] {
  return avps.flatMap((avp) =>
    getDirectorsForAvp(avp).map((d) => ({
      ...d,
      avpId: avp.id,
      avpName: avp.name,
      division: avp.division,
    })),
  )
}

// Flatten every LO across every AVP & Director with parent context + avgRevenue
export function getAllLoanOfficers(avps: AVP[]): LoanOfficerWithContext[] {
  return avps.flatMap((avp) => {
    const directors = getDirectorsForAvp(avp)
    return directors.flatMap((dir) =>
      dir.loanOfficers.map((lo) => ({
        ...lo,
        avgRevenue: lo.loansClosed > 0 ? lo.totalRevenue / lo.loansClosed : 0,
        avpId: avp.id,
        avpName: avp.name,
        directorId: dir.id,
        directorName: dir.name,
        division: avp.division,
      })),
    )
  })
}
